import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl } from 'react-intl'
import $ from 'jquery'
import ActionButton from "../../common/button/actionbutton.component.jsx"
import IntegrationSelect from '../../integration/integrationSelect.component.jsx';

class ImportProductsModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            modalId: this.props.modalId || 'products-import-modal',
            integrationKey: this.props.integrationKey || '',
            importAll: this.props.importAll || false,
            productType: this.props.productType || 'products' //Could be 'products' || 'products-matrix'  
        }
        this.closeModal = this.closeModal.bind(this)
        this.startImport = this.startImport.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onSelect = this.onSelect.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
    }

    componentDidUpdate(prevProps) {
        if (this.props.integrationKey !== prevProps.integrationKey) {
            this.setState({
                integrationKey: this.props.integrationKey,
            })
        }
    }
    closeModal(event) {
        event.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }

    startProductImport(event, productType) {
        AppContext.getApiClient().post('/imports', {
            integrationKey: this.state.integrationKey,
            type: productType,
            importAll: this.state.importAll,
        }).then(this.closeModal(event))
    }

    syncProductImport(event, productType) {
        const endPoint = '/sync/' + productType
        AppContext.getApiClient().post(endPoint, {}).then(this.closeModal(event))
    }

    startImport(event) {
        event.preventDefault()
        if (this.state.importAll) {
                this.startProductImport(event, this.state.productType)
        } else {
            this.syncProductImport(event, this.state.productType)
        }

    }

    handleChange(event) {
        this.setState({
            importAll: event.target.id === 'importAll',
        })
    }

    onSelect(value) {
        this.setState({
            integrationKey: value
        })
        this.props.onChangeIntegrationSelect(value)
    }

    supportsWebhooks() {
        let integration = AppContext.integrations.find(i => i.attributes && i.attributes.integrationKey === this.props.integrationKey)
        return integration?.attributes.features.includes("webhook-management")
    }

    render() {
        return (
            <div className="modal"
                id={this.state.modalId}
                role="dialog"
                aria-labelledby={this.state.modalId + "Label"}
                aria-hidden="true"
                data-backdrop="static"
                data-keyboard="false"
            >
                <div className="modal-dialog modal-signature" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title h5" id={this.modalId + "Label"}>
                                <FormattedMessage
                                    id="common.products_import.modal.title"
                                    defaultMessage="Import products"
                                />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="form-group row mb-0">
                                    <div className="col-12 mt-2 mb-2">
                                        <div className="custom-control custom-radio mb-4" onChange={this.handleChange}>
                                            <input type="radio" id="importAll" name="importProducts" checked={this.state.importAll} className="custom-control-input" />
                                            <label className="custom-control-label" for="importAll"> <FormattedMessage
                                                id="common.all_products_import.modal"
                                                defaultMessage="Import all products"
                                            /></label>
                                        </div>

                                        {!this.supportsWebhooks() &&
                                            <div className="custom-control custom-radio mb-2" value={'importNewProducts'} onChange={this.handleChange}>
                                                <input type="radio" id="importNew" name="importProducts" className="custom-control-input" checked={!this.state.importAll} />
                                                <label className="custom-control-label" for="importNew"><FormattedMessage
                                                    id="common.new_products_import.modal"
                                                    defaultMessage="Import new products only"
                                                /></label>
                                            </div>
                                        }

                                        <div className="col-6">
                                            <IntegrationSelect
                                                multi={false}
                                                defaultInputValue={this.state.integrationKey}
                                                value={this.state.integrationKey}
                                                onChange={this.onSelect}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                                <FormattedMessage
                                    id="common.products_import.modal.close_btn"
                                    defaultMessage="Close"
                                />
                            </button>
                            <ActionButton onClick={this.startImport} disabled={!this.state.integrationKey} className="btn btn-primary">
                                <FormattedMessage
                                    id="common.products_import.modal.send_btn"
                                    defaultMessage="Start now"
                                />
                            </ActionButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(ImportProductsModal)



// WEBPACK FOOTER //
// ./src/product/import/importproductsmodal.component.jsx